import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Breadcrumb, Spin } from 'antd';
import { Data } from '../data/Data';
import OrganicNonOrganic from '../components/charts/OrganicNonOrganic';
import SoilOrganicCarbon from '../components/charts/SoilOrganicCarbon';

function Report() {    
    const { id } = useParams();
    const [loading, setLoading] = useState(true);

    const report = Data.find((item) => item.id === parseInt(id));

    useEffect(() => {
        // Simulate an API call
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    if (!report) {
        return <div>Report not found</div>;
    }

    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '20px' }}>
                <h1 style={{ color: '#102F10' }}>
                    <Breadcrumb
                        items={[
                            {
                                title: <a href="/">Home</a>,
                            },
                            {
                                title: <a href="/reports">Reports</a>,
                            },
                            {
                                title: `${report.title}`,
                            },
                        ]}
                    />
                </h1>
            </div>
            <Spin spinning={loading} size="large">
                <Row gutter={[32, 24]}>
                    <Col xs={24} >
                        <div>
                            <h1 style={{ color: '#102F10' }}>{report.title}</h1>
                        </div>
                    </Col>
                    <Col span={12} xs={24} xl={12}>
                        <div className="report_col"><OrganicNonOrganic/></div>
                    </Col>
                    <Col span={12} xs={24} xl={12}>
                        <div className="report_col"><SoilOrganicCarbon/></div>
                    </Col>
                    <Col span={12} xs={24} >
                        <div className="report_col" style={{ backgroundColor: '#FFF'}}>
                            <div className="report_description" style={{ textAlign: 'start', padding: '10px 20px' }}>
                                <p>The soil analysis conducted using the NeoSpectra scanner on sample SU42C_1 reveals a Soil Organic Carbon (SOC) percentage of 1.74%. This data holds significance in agricultural and environmental contexts, as SOC levels are indicative of soil fertility, nutrient availability, and overall soil health. Understanding the organic carbon content in soil is crucial for optimizing agricultural practices, enhancing crop productivity, and implementing sustainable soil management strategies. Moreover, this analysis contributes to broader efforts aimed at monitoring and improving soil quality, which is essential for maintaining ecosystem health and resilience in the face of environmental challenges such as climate change and land degradation.</p>
                            </div>
                        </div>
                    </Col>
                </Row> 
            </Spin>
         
        </>
    );
}

export default Report;
